import React from 'react';
import DATA from '../../../assets/data';
import './demandPlannerTabs.scss';

const DemandPlannerTabs = (props) => {

    return (
        <div className='dp-tabs-container'>
            <div className='dp-tabs-sub-container'>
                {
                    DATA.DEMAND_PLANNER_TYPES.map((tab, ind) => (
                        <div key={tab+ind} className={`tab ${props.activeTabIndex === ind ? 'active-tab' : ''}`} onClick={() => props.handleTabToggle(ind)}>
                            {tab.label}
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default DemandPlannerTabs;